import React from 'react';
import { Calendar, MapPin, ExternalLink } from 'lucide-react';
import {
  eventosFuturos,
  eventosPasados,
  modalidadLabel,
  rolLabel,
  formatFechaLarga,
  formatFechaCorta
} from '../data/eventos';
import './Eventos.css';

const Eventos = () => {
  const futuros = eventosFuturos();
  const pasados = eventosPasados();

  const handleImgError = (e) => {
    e.currentTarget.parentElement?.classList.add('evento-card__image--empty');
    e.currentTarget.style.display = 'none';
  };

  return (
    <div className="eventos-container">
      {/* Hero */}
      <section className="eventos-hero">
        <div className="eventos-hero-content">
          <h1 className="eventos-hero-title">Eventos</h1>
          <p className="eventos-hero-subtitle">
            Jornadas, ferias y encuentros técnicos en los que participamos para acompañar
            el desarrollo de la industria.
          </p>
        </div>
      </section>

      {/* Próximos eventos */}
      <section className="eventos-section eventos-section--proximos">
        <div className="container">
          <h2 className="eventos-section-title">Próximos eventos</h2>

          {futuros.length === 0 ? (
            <div className="eventos-empty">
              <Calendar size={32} className="eventos-empty-icon" />
              <p className="eventos-empty-text">Próximamente...</p>
              <p className="eventos-empty-subtext">
                Estamos preparando nuevas participaciones. Volvé pronto para conocer
                las próximas fechas.
              </p>
            </div>
          ) : (
            <div className="eventos-proximos-grid">
              {futuros.map((evento) => (
                <article key={evento.id} className="evento-card">
                  <div className="evento-card__image">
                    {evento.imagen ? (
                      <img
                        src={evento.imagen}
                        alt={evento.titulo}
                        loading="lazy"
                        onError={handleImgError}
                      />
                    ) : null}
                    <div className="evento-card__badges">
                      <span className={`evento-badge evento-badge--modalidad evento-badge--${evento.modalidad}`}>
                        <MapPin size={13} />
                        {modalidadLabel(evento.modalidad)}
                      </span>
                      {evento.rol && (
                        <span className={`evento-badge evento-badge--rol evento-badge--rol-${evento.rol}`}>
                          {rolLabel(evento.rol)}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="evento-card__body">
                    <p className="evento-card__fecha">
                      <Calendar size={15} />
                      {formatFechaLarga(evento.fecha)}
                    </p>
                    <h3 className="evento-card__titulo">{evento.titulo}</h3>
                    <p className="evento-card__organizador">
                      Organiza: <strong>{evento.organizador}</strong>
                      {evento.organizadorNombre && evento.organizadorNombre !== evento.organizador
                        ? ` — ${evento.organizadorNombre}`
                        : ''}
                    </p>
                    <p className="evento-card__descripcion">{evento.descripcion}</p>
                    {evento.link && (
                      <a
                        href={evento.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="evento-card__link"
                      >
                        Más información
                        <ExternalLink size={14} />
                      </a>
                    )}
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Eventos pasados */}
      {pasados.length > 0 && (
        <section className="eventos-section eventos-section--pasados">
          <div className="container">
            <h2 className="eventos-section-title">Eventos pasados</h2>

            <ul className="eventos-pasados-lista">
              {pasados.map((evento) => (
                <li key={evento.id} className="evento-pasado">
                  <div className="evento-pasado__fecha">
                    <Calendar size={14} />
                    {formatFechaCorta(evento.fecha)}
                  </div>
                  <div className="evento-pasado__main">
                    <h3 className="evento-pasado__titulo">{evento.titulo}</h3>
                    <p className="evento-pasado__organizador">
                      Organiza: <strong>{evento.organizador}</strong>
                    </p>
                  </div>
                  {evento.rol && (
                    <span className={`evento-badge evento-badge--rol evento-badge--rol-${evento.rol}`}>
                      {rolLabel(evento.rol)}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </section>
      )}
    </div>
  );
};

export default Eventos;
